import React, { Component } from 'react'
import Axios from 'axios';
import PersonInput from './PersonInput';

class AxiosList extends Component {

    state = {
        persons: [],
        errMsg: ""
    }

    componentDidMount() {
        Axios.get('https://jsonplaceholder.typicode.com/users')
        .then(res => {
            console.log((res));
            this.setState({ persons: res.data });
        })
        .catch(err => {
          console.log(err)
          this.setState({errMsg: "Error retrieving data"})
        })
    }

  render() {
    const { errMsg } = this.state
    return (
      <>
        <PersonInput />

        <div className="ui  middle aligned selection relaxed divided list">
          {this.state.persons.map(person => (
            <div key={person.id} className="item">
                <i className="large github middle aligned icon"></i>
                <div className="content">
                  <span>
                  <p className="header">
                   {person.name}
                  </p>
                  <div className="description">
                  Email: {person.email}
                  </div>
                  </span>
                </div>
            </div>
          ))}
        </div>

        {/* {
          here, instead of writting
          this.state.persons => persons==@
          we can write, below after
          --- render() ---
          const { persons, errMsg } = this.state
          --- return ---
          @==
          {
          persons.length ?
          persons.map(person => <div key={person.id}>
            {person.name}
          </div>) : null
          } */}
          { errMsg ? <h3>{errMsg}</h3> : null}
      </>
    )
  }
}

export default AxiosList;
